<div class="tonnage-header">
  <div >
   <span class="tonnage-title">Tonnage Ratings</span>
    <div class="tonnage-form-container">
      <form [formGroup]="trainForm" (ngSubmit)="searchTonnage()" novalidate>
        <div class="inputs-parent">
          <div class="inputs-container">
            <div class="tonnage-input-field">
              <label for="division" class="block input-label">Division</label>
              <p-dropdown formControlName="division"
                          [options]="divisions"
                          placeholder="Select Division"
                          [showClear]="true"
                          id="division"
                          optionLabel="name">
              </p-dropdown>
              <small class="p-error block"
                     *ngIf="trainForm.get('division')?.invalid">
                Division is required
              </small>
            </div>
            <div class="tonnage-input-field">
              <label for="subdivision" class="block input-label">Subdivision</label>
              <p-dropdown formControlName="subdivision"
                          [options]="subdivisions"
                          placeholder="Select Subdivision"
                          [showClear]="true"
                          id="subdivision"
                          optionLabel="name"
                          >
              </p-dropdown>
            </div>
            <div class="tonnage-input-field">
              <label for="stationId" class="input-label block">Station ID</label>
              <p-dropdown formControlName="stationId"
                          [options]="stationids"
                          placeholder="Select Station ID"
                          [showClear]="true"
                          id="stationId"
                          optionLabel="name"
                          >
              </p-dropdown>
            </div>

            
          </div>   
          <div class="buttons-container">
            <button label="Cancel" (click)="cancelTonnageForm()" class="tonnage-button p-button-secondary">Cancel</button>
            <button pButton type="submit" label="Submit" class="tonnage-button p-button-primary ml-3" [disabled]="trainForm.invalid">Submit</button>
           
          </div>
          <div class="export-icons" *ngIf="isResultsAvailable()">
            <div class="icons-group" style="float:left; padding-right: 20%;">
              <label>Excel</label>
              <i class="fa fa-download" aria-hidden="true" title="Export to Excel" (click)="exportExcel()"></i>
            </div>
            <div class="icons-group">
              <label>PDF</label>
              <i class="fa fa-download" aria-hidden="true" title="Export to PDF" (click)="exportPDF()"></i>
            </div>
          </div>     
        </div>
      </form>      
    </div>
      <div class="all-divisions-buttons-container" *ngIf="isHasAllDivisionsDownloadAccess"> 
      <button pButton type="button" (click)="exportAllDivisionsExcel()" class="tonnage-button p-button-secondary " >All Divisions Excel</button>
      <button pButton  type="button" (click)="exportAllDivisionsPDF()"   class="tonnage-button  p-button-secondary" >All Divisions PDF</button>
  </div>
  </div>

  <div class="tonnage-results" >

    <lms-lms-tonnage-lmto-table *ngIf="showDataTable"
      [lmtoTonnageRatings]="tonnageRatingHandlerData"
      [lmtoHeadings]="lmtoHeadingsUI">
    </lms-lms-tonnage-lmto-table>

  </div>
